import { lazy } from 'react'
import type { RouteWithMeta } from '../types'
import { withSuspense } from '../utils/withSuspense'

// Lazy loading으로 성능 최적화
const PaymentPage = lazy(() => import('@/pages/record/payment/PaymentPage'))
const TicketPage = lazy(() => import('@/pages/record/ticket/TicketPage'))
const BonusPage = lazy(() => import('@/pages/record/bonus/BonusPage'))

/**
 * 결제 및 구매 관리 라우트
 * - 푸딩 충전 이력
 * - 이용권 구매 이력
 * - 보너스 지급 및 이력
 */

export const recordRoutes: RouteWithMeta = {
  path: 'record',
  meta: {
    label: '결제 및 구매',
    showInMenu: true,
    icon: ''
  },
  children: [
    // ===== 푸딩 충전 이력 =====
    {
      path: 'payment',
      element: withSuspense(<PaymentPage/>),
      meta: {
        label: '푸딩 충전 이력',
        showInMenu: true,
      }
    },

    // ===== 이용권 구매 이력 =====
    {
      path: 'ticket',
      element: withSuspense(<TicketPage/>),
      meta: {
        label: '이용권 구매 이력',
        showInMenu: true,
      }
    },

    // ===== 보너스 지급 및 이력 =====
    {
      path: 'bonus',
      element: withSuspense(<BonusPage/>),
      meta: {
        label: '보너스 지급 및 이력',
        showInMenu: true,
      }
    },
  ]
}